/* import __COLOCATED_TEMPLATE__ from './list.hbs'; */
/* RESPONSIBLE TEAM: team-conversational-knowledge */

import Component from '@glimmer/component';
import type AiContentLibraryApi from 'embercom/lib/ai-content-library/list-api';
import { restartableTask } from 'ember-concurrency-decorators';
import { type TaskGenerator } from 'ember-concurrency';

import { taskFor } from 'ember-concurrency-ts';

interface Args {
  listApi: AiContentLibraryApi;
  activeContentId?: number;
  activeContentType?: string;
  showTopics?: boolean;
}

export default class List extends Component<Args> {
  get totalCount() {
    return this.args.listApi.totalCount;
  }

  get isLoading() {
    return this.args.listApi.isLoadingPage && !this.isPaginating;
  }

  get isPaginating() {
    return taskFor(this.paginate).isRunning;
  }

  @restartableTask
  *paginate(): TaskGenerator<void> {
    if (!this.args.listApi.isLoadingPage) {
      yield this.args.listApi.loadPage();
    }
  }
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'AiAgent::Suggestions::List': typeof List;
    'ai-agent/suggestions/list': typeof List;
  }
}
